<template>
  <div v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">资格符合性审查</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="serachData"
            ></el-button>
          </el-input>
          <el-button type="primary" @click="lookTbwj" :disabled="waitLoading"
            >查看投标文件</el-button
          >
          <el-button
            type="primary"
            @click="calculate"
            :disabled="kbxmlc.zt == '2'"
            >计算</el-button
          >
          <el-button
            type="primary"
            @click="goCustomLink"
            :disabled="waitLoading"
            >抽取</el-button
          >
          <el-button type="primary" @click="lookRules" :disabled="waitLoading"
            >查看规则</el-button
          >
        </div>
      </div>
      <p class="red" style="padding-bottom: 10px">
        <span
          style="margin-right: 10px"
          v-for="item in parameterExtractionResults"
          :key="item.code"
        >
          <span>{{ item.parameter || "" }}</span>
          <span>{{ item.value || "" }}</span>
          <span>{{ item.unit || "" }}</span>
        </span>
      </p>
      <el-table
        ref="table"
        border
        :data="tableData"
        style="width: 100%"
        v-loading="waitLoading"
      >
        <el-table-column type="index" label="序号" width="60">
          <template slot-scope="scope">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="投标单位名称"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="scope">
            <div style="display: flex; align-items: center">
              <p>{{ scope.row.companyName }}</p>
              <div
                v-if="scope.row.lhtShowOrNo == 1"
                style="margin-left: 20px"
                class="btn-lht"
                @click="openLht(scope.row.lhtId)"
              >
                联合体
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in extraHead"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
        ></el-table-column>
        <el-table-column
          v-for="item in exhibitionList"
          :key="item.prop"
          :label="item.mc"
          :prop="item.prop"
        ></el-table-column>
        <el-table-column prop="complianceReview" label="符合性审查" width="120">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.complianceReview"
              v-if="kbxmlc.zt != '2' && role == 'Z'"
              class="small"
              @change="saveComplianceReview(scope.row)"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
            <template v-else>{{
              scope.row.complianceReview == 1
                ? "通过"
                : scope.row.complianceReview == 2
                ? "不通过"
                : ""
            }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div class="clear">
        <myPage
          class="rt"
          :total="total"
          :page-size="pageSize"
          :currentPage="currentPage"
          @changePage="changePage"
        ></myPage>
      </div>
    </div>
    <el-button
      type="primary lcNext"
      :disabled="!nextBool || !isOk || waitLoading"
      @click="nextBtn"
      v-if="kbxmlc.zt != '2'"
      >下一步</el-button
    >
    <!-- 添加投标单位弹窗 -->
    <el-dialog
      title="查看规则"
      :visible.sync="showRules"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p>{{ rules }}</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="showRules = false">确定</el-button>
      </div>
    </el-dialog>
    <lht-mark
      v-if="lhtVisible"
      :visible.sync="lhtVisible"
      :lhtId="lhtId"
    ></lht-mark>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import lhtMark from "@/components/lhtMark/index.vue";
import myPage from "../components/page";
export default {
  name: "zgfhxsc", //开评一体资格符合性审查
  components: {
    myPage,
    lhtMark,
  },
  data() {
    return {
      waitLoading: false,
      kbxmlc: {},
      djlcId: "", //当前节点状态
      d: null,
      adjustmentCoefficient: null,
      parameterExtractionResults: [],
      tableData: [],
      exhibitionList: [],
      extraHead: [],
      newOrOld: "0",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      options: [
        { label: "通过", id: "1" },
        { label: "不通过", id: "2" },
      ],
      tbdwmc: "",
      isOk: false,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      showRules: false,
      rules: [],
      unit: "",
      lhtVisible: false,
      lhtId: "",
      nextBool: false,
    };
  },
  computed: {
    // 是否展示计算得分按钮
    isShowScore() {
      return this.kbxmlc.zt !== "2" && ["T", "A", "Z"].includes(this.role);
    },
  },
  watch: {
    tableData: {
      handler(newValue) {
        let bool = newValue.some((el) => el.complianceReview === "1");
        this.nextBool = bool;
      },
      deep: true,
    },
  },
  methods: {
    goCustomLink() {
      window.open(`/fhxscDraw?len=${this.tableData.length}`, "_blank");
    },
    openLht(id) {
      this.lhtVisible = true;
      this.lhtId = id;
    },
    //开评一体
    async lookRules() {
      this.rules =
        "按承包意向文件的递交顺序产生的承包意向人的顺序号码，随机抽取一个号码，发包人或代理机构对摇出号码对应单位进行资格审查，审查通过，确定为承包候选人。";
      this.showRules = true;
    },
    lookTbwj() {
      let { href } = this.$router.resolve({ name: "LookTbwj" });
      window.open(href, "_blank");
    },
    getData() {
      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      this.$api
        .getListInfoByKbxmId(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.waitLoading = false;
            this.kbxmlc = res.data.data.kbxmlc;
            // 新逻辑
            if (res.data.data.newOrOld === "1") {
              this.unit = res.data.data.unit;
              this.tableData = res.data.data.newPageInfo.list || [];
              this.tableData.forEach((el) => {
                if (
                  el.attributeMap &&
                  JSON.stringify(el.attributeMap) !== "{}"
                ) {
                  for (let key in el.attributeMap) {
                    el[key] = el.attributeMap[key];
                  }
                }
              });
              this.total = res.data.data.newPageInfo.total || 0;
              this.newOrOld = res.data.data.newOrOld;
              this.parameterExtractionResults =
                res.data.data.parameterExtractionResults || [];
              // 对中间值进行排序 并预设中间值的取值键名
              this.exhibitionList = (res.data.data.exhibition || [])
                .sort((a, b) => a.pxh - b.pxh)
                .map((item, index) => {
                  return {
                    ...item,
                    prop: `exhibition${index}`,
                  };
                });
              this.extraHead = res.data.data.head.map((el) => {
                return {
                  label: el.name,
                  prop: el.code,
                };
              });
              this.tableData.forEach((el) => {
                if (el.complianceReview === "0") {
                  el.complianceReview = "";
                  // 如果数据列表中 exhibition字段存在且不为空 则按照预设键名新增键并赋值
                }
                if (el?.exhibition) {
                  el.exhibition.split(",").forEach((item, index) => {
                    el[`exhibition${index}`] = item;
                  });
                } else {
                  // 如果无值 则预设键名 并赋值为空
                  this.exhibitionList.forEach((item) => {
                    el[item.prop] = "";
                  });
                }
              });
            } else {
              // 旧逻辑
              this.tableData = res.data.data.page.list;
              this.total = res.data.data.page.total;
              this.tableData.forEach((el) => {
                if (el.complianceReview == "0") {
                  el.complianceReview = "";
                }
              });
            }
            this.d = res.data.data.d;
            this.adjustmentCoefficient = res.data.data.adjustmentCoefficient;
            this.getComplianceReviewFlag();
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    /**
     * 中间值排序
     * @param exhibition
     */
    transformData(exhibition) {
      if (!exhibition || !exhibition.length) return [];
    },
    //查询
    serachData() {
      this.currentPage = 1;
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    async saveComplianceReview(row) {
      try {
        let para = [];
        para.push(row);
        this.waitLoading = true;
        let res = await this.$api.saveComplianceReview({
          projectResultInfo: para,
        });
        if (res.status == 200) {
          this.getComplianceReviewFlag();
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async getComplianceReviewFlag() {
      try {
        this.waitLoading = true;
        let res = await this.$api.getComplianceReviewFlag({
          djlcId: this.djlcId,
        });
        if (res.status == 200) {
          this.isOk = res.data.data;
        } else {
          this.$message({ type: "error", message: res.message });
        }
        console.log("=====");
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async calculate() {
      try {
        this.waitLoading = true;
        let param = {
          djlcId: this.djlcId,
        };
        let res = await this.$api.calculate(param);
        if (res.status == 200) {
          this.$message({ type: "success", message: "操作成功！" });
          this.getData();
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    nextBtn() {
      this.$confirm(
        "请确认是否提交数据并进入下一步，确认后评审结果不可修改",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let para = {
            flag: this.kbxmlc.ycdz,
          };
          this.$emit("nextBtn", para);
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.rules {
  p {
    line-height: 24px;
    margin-bottom: 10px;
  }
  margin-bottom: 30px;
}
::v-deep .small {
  .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
  .el-input__icon {
    line-height: 24px;
  }
}
</style>
